__turbopack_context__.v({
  "embla": "emblaCarousel-module-scss-module__ehGQ-W__embla",
  "embla__container": "emblaCarousel-module-scss-module__ehGQ-W__embla__container",
  "embla__slide": "emblaCarousel-module-scss-module__ehGQ-W__embla__slide",
});
